import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    CALCULATOR_INTRO_LOGGED,
    CALCULATOR_INTRO_TITLE,
} from '../../components/calculator/calculatorIntroCopy';
import PriceCalculatorPanel from '../../components/calculator/PriceCalculatorPanel';

function CalculatorPage() {
    const navigate = useNavigate();

    return (
        <div>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" onClick={() => navigate('/admin')} to="/admin">
                    Dashboard
                </Link>
                <Typography color="text.primary">Calculadora de preço</Typography>
            </Breadcrumbs>
            <Box sx={{ my: 2 }} />
            <PriceCalculatorPanel
                variant="admin"
                introTitle={CALCULATOR_INTRO_TITLE}
                intro={CALCULATOR_INTRO_LOGGED}
            />
        </div>
    );
}

export default CalculatorPage;
